import { ElementRef } from '@angular/core';
import './../helper/modernizr.js';
var SvgFallbackDirective = /** @class */ (function () {
    function SvgFallbackDirective(elem) {
        this.elem = elem;
    }
    Object.defineProperty(SvgFallbackDirective.prototype, "svgFallback", {
        set: function (logoSrc) {
            var isIE11 = /(MSIE|rv:11.0|Edge)/i.test(navigator.userAgent);
            if ((!Modernizr.svg || isIE11) && logoSrc && this.elem.nativeElement) {
                var imgAlt = $(this.elem.nativeElement)
                    .find('title')
                    .text();
                var imgPath = logoSrc.split('\.svg');
                $(this.elem.nativeElement)
                    .replaceWith("<img class=\"img-responsive\" alt=\"" + imgAlt + "\" src=\"" + imgPath[0] + ".png\">");
            }
        },
        enumerable: true,
        configurable: true
    });
    return SvgFallbackDirective;
}());
export { SvgFallbackDirective };
